import React from 'react';

import { Redirect, Route, Switch } from 'react-router-dom';

import Landing from './landing/index';
import SignupComponent from './signup/index';
import LoginComponent from './login/index';
import PasswordRecoveryComponent from './password-recovery/index';
import { ActivationByCode, ActivationByCodeHash } from './signup/activation';
import Solutions from "./landing/Solutions";
import Contacts from "./landing/Contacts";

import ProjectMainComponent from './dashboard/projects/index';
import PageNotFound from './not-found';
import Profile from './dashboard/profile/index'
import Settings from './dashboard/settings/index'
import Billing from './dashboard/billing/index'
import Payments from './dashboard/payments/index'
import Integration from './dashboard/integration/index'
import AnalyticsRouter from './dashboard/analytics/routing';
import DataExchange from './dashboard/data-exchange/index';
import Info from './dashboard/info/index';
import LogoutComponent from './login/logout';
import AuthClient from '../auth';

import PrivateRoute from './login/route';

import './main.css'
import DashboardRoute from "./dashboard/route";
import {RecoveryConfirmByCode, RecoveryConfirmByCodeHash} from "./password-recovery/confirm";
import {Loading} from "./utils/loading";


function isLoggedIn() {
  return AuthClient.isLoggedIn();
}

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lastPath: null
    }
  }
  componentDidUpdate() {
    if (window.location.pathname !== this.state.lastPath) {
        this.setState({
            lastPath: window.location.pathname
        })
    }
  }
  render() {
    return (
      <div className="main-wrapper">
        <Switch>
          <Route exact path="/" render={(props) => (
            <Landing {...props} isLoggedIn={isLoggedIn()} />
          )}/>
          <Route path="/login" component={LoginComponent}/>
          <Route exact path="/solutions" render={(props) => (
            <Solutions {...props} isLoggedIn={isLoggedIn()} />
          )} />
          <Route exact path="/contacts" render={(props) => (
            <Contacts {...props} isLoggedIn={isLoggedIn()} />
          )} />
          <Route exact path="/signup" component={SignupComponent}/>
          <Route exact path="/signup/confirm" component={ActivationByCode}/>
          <Route exact path="/signup/confirm/:hash" component={ActivationByCodeHash}/>
          <Route exact path="/recovery" component={PasswordRecoveryComponent}/>
          <Route exact path="/recovery/confirm" component={RecoveryConfirmByCode}/>
          <Route exact path="/recovery/confirm/:hash" component={RecoveryConfirmByCodeHash}/>
          <PrivateRoute path="/logout" authenticated={isLoggedIn} render={(props) => (
            <LogoutComponent {...props} fromPath={this.state.lastPath}/>
          )}

          />

          <Route exact path="/dashboard" render={() => (<Redirect to='/dashboard/projects' />)} />
          <DashboardRoute exact path="/dashboard/projects" component={ProjectMainComponent} authenticated={isLoggedIn}/>
          <PrivateRoute path="/dashboard/analytics" component={AnalyticsRouter} authenticated={isLoggedIn}/>
          <DashboardRoute exact path="/dashboard/data-exchange" component={DataExchange} authenticated={isLoggedIn}/>
          <DashboardRoute exact path="/dashboard/info" component={Info} authenticated={isLoggedIn}/>
          <DashboardRoute exact path="/dashboard/profile" component={Profile} authenticated={isLoggedIn}/>
          <DashboardRoute exact path="/dashboard/settings" component={Settings} authenticated={isLoggedIn}/>
          <DashboardRoute exact path="/dashboard/billing" component={Billing} authenticated={isLoggedIn}/>
          <DashboardRoute exact path="/dashboard/payments" component={Payments} authenticated={isLoggedIn}/>
          <DashboardRoute exact path="/dashboard/integration" component={Integration} authenticated={isLoggedIn}/>

          <Route component={PageNotFound}/>
        </Switch>
      </div>
    )
  }
}


export default Main


// WEBPACK FOOTER //
// ./src/components/routing.js